import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RouterManagerService } from './router-manager.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private storageService: RouterManagerService, private router: Router) { }

  canActivate(): boolean {
    if (!this.storageService.isAuthorized()) {
      this.router.navigateByUrl("/login");
      return false;
    }

    return true;
  }
}
